import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button", "icon"];

  toggle() {
    const visible = this.inputTarget.type === "password";
    this.inputTarget.type = visible ? "text" : "password";
    this.buttonTarget.setAttribute("aria-label", visible ? "隐藏密码" : "显示密码");
    this.buttonTarget.setAttribute("aria-pressed", String(visible));
    this.iconTarget.classList.toggle("lucide--eye", !visible);
    this.iconTarget.classList.toggle("lucide--eye-off", visible);
  }
}
